/**
 * Creates a place object based on the provided data.
 *
 * @param {Object} data - The input data for creating the place object.
 * @param {string} data.collectionId - The ID of the collection the place belongs to.
 * @param {string} data.id - The unique identifier for the place.
 * @param {string} data.uniqueId - A globally unique identifier for the place.
 * @param {string} data.locale - The locale of the place (e.g., "en", "no").
 * @param {string} data.title - The title of the place.
 * @param {string} data.source - The source of the place data.
 * @param {string} data.sourceId - The source-specific identifier for the place.
 * @param {Object} data.content - The content object containing additional place details.
 * @param {string} data.content.name - The name of the place.
 * @param {string} [data.content.nameAndTitle] - Optional combined name and title for the place.
 *
 * @returns {Object} The constructed place object.
 */
export const createPlaceObject = (data) => {
    const {collectionId, id, uniqueId, locale, title, source, sourceId, content} = data;
    const {name, nameAndTitle = undefined} = content;

    const placeObj = {
        referenceType: "place",
        collectionId: collectionId,
        reference: {
            id: id,
            uniqueId: uniqueId,
            locale: locale,
            _action: "put",
            title: title,
            status: "published",
            source: source,
            sourceId: sourceId,
            content: {
                name: name,
            }
        },
    };

    if (typeof (nameAndTitle) !== "undefined") {
        // Store the complete type definition for KulturNav place-objects.
        placeObj.reference.content.nameAndTitle = nameAndTitle;
    }

    return placeObj;
};
